// Reusable Yup validators (single source of truth for common form fields)
import * as Yup from "yup";

/** ------------------
 *  String-based reusable fields
 * --------------------------*/
const requiredString = (msg = "This field is required") =>
  Yup.string().trim().required(msg);

const nameField = (msg = "Name is required") =>
  Yup.string()
    .trim()
    .min(2, "Name must be at least 2 characters")
    .max(50, "Name cannot exceed 50 characters")
    .required(msg);

const emailField = (msg = "Enter a valid email address") =>
  Yup.string().trim().email(msg).required(msg);

const optionalEmail = (msg = "Enter a valid email address") =>
  Yup.string().trim().email(msg).nullable().notRequired();

/** -----------------------------
 *  Number-like string fields
 * ----------------------------- */
const mobileField = (msg = "Mobile number is required") =>
  Yup.string()
    .matches(/^[0-9]{10}$/, "Mobile number must be exactly 10 digits")
    .required(msg);

const pinField = (msg = "Enter a valid pin code") =>
  Yup.string()
    .matches(/^[0-9]{3,10}$/, msg)
    .nullable()
    .notRequired();

const panField = (msg = "Enter a valid PAN (e.g., ABCDE1234F)") =>
  Yup.string()
    .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, msg)
    .required("PAN is required");

const aadharField = (msg = "Enter a valid 12-digit Aadhar number") =>
  Yup.string()
    .matches(/^[0-9]{12}$/, msg)
    .required("Aadhar is required");

/** -----------------------
 *  Credentials & security
 * ------------------------*/
const passwordField = (msg = "Password is required") =>
  Yup.string()
    .min(6, "Password must be at least 6 characters long")
    .max(100, "Password cannot exceed 100 characters")
    .required(msg);

/** ------------------------
 *  URLs / Enum
 * -------------------------*/
const websiteField = (msg = "Enter a valid website URL") =>
  Yup.string()
    .trim()
    .matches(
      /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/.*)?$/,
      msg
    )
    .nullable()
    .notRequired();

const enumField = (values = [], msg = "Invalid value") =>
  Yup.string().oneOf(values, msg).required(msg);


const validators = {
  requiredString,
  nameField,
  emailField,
  optionalEmail,
  mobileField,
  pinField,
  panField,
  aadharField,
  passwordField,
  websiteField,
  enumField,
};

export default validators;
